import axios from '../../axios/ctiConfig';
import ctiRequest from '../../axios/ctiRequests';
import * as actionTypes from './actionTypes';
import {notify} from '../../helpers/utility';

export const queueCallsStart = () => {
  return {
    type: actionTypes.QUEUE_CALLS_START,
  };
};

export const queueCallsFail = (error) => {
  return {
    type: actionTypes.QUEUE_CALLS_FAIL,
    error: error,
  };
};

export const queueCallsSuccess = (queueCallData) => {
  return {
    type: actionTypes.QUEUE_CALLS_SUCCESS,
    queueCallData: queueCallData,
  };
};

export const queueCalls = (agentId) => {
  //console.log(agentId);
  return (dispatch) => {
    dispatch(queueCallsStart());
    ctiRequest['QUEUE_LIVE_AGENT_LIST'].agent_id = agentId;
    window.clientIP = localStorage.getItem('clientIP') ? localStorage.getItem('clientIP') : '127.0.0.1';
    ctiRequest['QUEUE_LIVE_AGENT_LIST'].ip = window.clientIP;
    axios
      .post('/', ctiRequest['QUEUE_LIVE_AGENT_LIST'])
      .then((result) => {
        if (result.data.response.status === 'SUCCESS') {
          //console.log(result.data.response.total_calls);
          dispatch(queueCallsSuccess(result.data.response.total_calls));
        } else {
          notify('Call Queue Error: ' + result.data.response.reason, 'call-queue');
          dispatch(queueCallsFail(result.data.response.reason));
        }
      })
      .catch((err) => {
        console.log(err);
        notify('Call Queue Error', 'call-queue');
        dispatch(queueCallsFail(err));
      });
  };
};